import React, { Component } from 'react'
import { translate } from 'react-i18next'

// Exmaple url formats:
// https://gist.github.com/Glurt/ea11b690ba4b1278e049
// https://stackoverflow.com/questions/7693218/youtube-i-d-parsing-for-new-url-formats

class VCVideo extends Component {
  render() {
    const width = 525
    const height = 295

    let className
    if (this.props.align === "center")
      className = "center"
    if (this.props.align === "left")
      className = "left"
    if (this.props.align === "right")
      className = "right"

    let youtube
    if (this.props.link && this.props.link.match(/^https:\/\/youtu.be\/(.+)$/i))
      youtube = this.props.link.match(/^https:\/\/youtu.be\/(.+)$/i)[1]
    if (this.props.link && this.props.link.match(/^https:\/\/www.youtube.com\/watch\?v=(.+)$/i))
      youtube = this.props.link.match(/^https:\/\/www.youtube.com\/watch\?v=(.+)$/i)[1]
    if (this.props.link && this.props.link.match(/^https:\/\/www.youtube.com\/embed\/(.+)$/i))
      youtube = this.props.link.match(/^https:\/\/www.youtube.com\/embed\/(.+)$/i)[1]

    let vimeo
      if (this.props.link && this.props.link.match(/^https:\/\/vimeo.com\/(.+)$/i))
        vimeo = this.props.link.match(/^https:\/\/vimeo.com\/(.+)$/i)[1]

    if (youtube)
      return <div className={className}><iframe title={youtube} width={width} height={height} src={`https://www.youtube.com/embed/${youtube}`} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe></div>

    if (vimeo)
      return <div className={className}><iframe title={vimeo} src={`https://player.vimeo.com/video/${vimeo}`} width={width} height={height} frameBorder="0" allowFullScreen /></div>
  }
}

export default translate()(VCVideo)


// WEBPACK FOOTER //
// ./src/components/VCVideo.js